import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { ManageFootballSubTeam } from "../../../../../../commons/models/football/admin/manage-football-sub-team";
import { setFetchedTeamData } from "../../../fetched-team-slice";

export interface IManageSubTeamInfoState {
  subTeamInfo: ManageFootballSubTeam;
  subTeamInfoStatus: StatusEnum;
}

const initialState: IManageSubTeamInfoState = {
  subTeamInfo: new ManageFootballSubTeam(),
  subTeamInfoStatus: StatusEnum.Idle,
};

export interface subTeamFetchOption {
  teamId: number;
  subTeamId: number;
}

export const fetchManageSubTeam = createAsyncThunk(
  "manage/subTeamDetail",
  async (oprions: subTeamFetchOption, thunkAPI) => {
    try {
      const subTeam = await manageFootballTeamService.getSubTeam(oprions.teamId, oprions.subTeamId);
      thunkAPI.dispatch(setFetchedTeamData(subTeam));
      return subTeam;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageSubTeamSlice = createSlice({
  name: "footballManageTeam",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamInfo(state) {
      state.subTeamInfo = new ManageFootballSubTeam();
      state.subTeamInfoStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSubTeam.pending, (state) => {
        state.subTeamInfoStatus = StatusEnum.Loading;
      })
      .addCase(fetchManageSubTeam.fulfilled, (state, action: PayloadAction<ManageFootballSubTeam>) => {
        state.subTeamInfoStatus = StatusEnum.Succeeded;
        state.subTeamInfo = action.payload;
      })
      .addCase(fetchManageSubTeam.rejected, (state) => {
        state.subTeamInfoStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamInfo } = footballManageSubTeamSlice.actions;
export default footballManageSubTeamSlice.reducer;
